<template>
    <header class="bg-white admin-header">
        <div class="d-flex align-center justify-between">
            <img src="~@/assets/images/Logo.svg" alt="" width="100">
            <span class="ml-auto d-flex align-center">
                
                <el-dropdown trigger="click" class="ml-20" :hide-on-click="false">
                    <span class="el-dropdown-link">
                        <div class="circle cursor-pointer">
                            <el-image 
                                :src="currentUser.avatar ||  ''"
                                fit="cover"
                                v-if="currentUser.hasOwnProperty('avatar')"
                                class="w-100 h-100"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                            <font-awesome-icon :icon="['fas', 'user']" style="width:30px" v-else/>
                        </div>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu >
                            <el-dropdown-item command="e"  disabled >
                                <div class="font-20 text-center w-100" >
                                    Hello {{currentUser.displayName}}
                                </div>
                            </el-dropdown-item>
                            <!-- <el-dropdown-item command="e" divided >
                                <router-link   to="/admin-panel/user-profile" class="no-decoration color-brown font-16 d-flex align-center">
                                    <font-awesome-icon :icon="['fas', 'address-card']" style="width:18px" class="mr-10" />
                                    Profile
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item command="e" divided >
                                <router-link   to="/admin-panel/inbox-management" class="no-decoration color-brown font-16 d-flex align-center">
                                    <el-badge is-dot class="item" v-if="unreadMessages" po >
                                        <font-awesome-icon :icon="['fas', 'envelope']" style="width:18px" class="mr-10" />
                                    </el-badge>
                                    <font-awesome-icon :icon="['fas', 'envelope']" style="width:18px" class="mr-10" v-else />
                                    Inbox
                                </router-link>
                            </el-dropdown-item> -->
                            <el-dropdown-item command="e" divided >
                                <el-popconfirm
                                    title="Are you sure to logout?"
                                    @confirm="logout()"
                                >
                                    <template #reference>
                                        <span class="color-brown font-16 d-flex align-center">
                                            <font-awesome-icon icon="fa-solid fa-right-from-bracket" class="mr-10" style="width:18px" />
                                            logout
                                        </span>
                                    </template>
                                </el-popconfirm>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </span>
        </div>
    </header>
</template>
<script>
export default {
    computed:{
        currentUser(){
            return JSON.parse(localStorage.getItem('adminStore'))?.admin?.user || {}
        },
        cachedMessages(){
            return JSON.parse(localStorage.getItem('adminStore'))?.admin?.messages?.content || []
        },
        unreadMessages(){
            const unreadMessage = this.cachedMessages.filter(msg => !msg.read);
            return unreadMessage.length
        }
    },
    mounted(){
        if (!JSON.parse(localStorage.getItem('adminStore'))?.admin.user){
            this.logout()
        }
    },
    methods:{
        logout(){
            localStorage.removeItem('awsatLoggedIn');
            localStorage.removeItem('access_token');
            localStorage.removeItem('adminStore');

            this.$router.push('/admin')
        },
        async publishChanges(){
            const response = await this.$store.dispatch('publishChanges');
            this.$notify({
                title:String(response.status),
                message:response.data.message,
                type:'success',
            })
        }
    }
}
</script>
<style lang="scss">
@import '~@/assets/styles/variables';
    .circle{
        background-color: $white;
        border: 3px solid $theme;
        color: $theme ;
        padding: 0px;
        width:60px;
        height:60px;
        display:flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    header{
        padding: 15px 30px;
        
      

        box-shadow: -1px 2px 38px -15px rgba($color:$theme,$alpha:0.86);
        -webkit-box-shadow: -1px 2px 38px -15px rgba($color:$theme,$alpha:0.86);
        -moz-box-shadow: -1px 2px 38px -15px rgba($color:$theme,$alpha:0.86);
    }
    .admin-header {
        // position: sticky;
        // top: 0px;
        // z-index: 999;
    }
</style>